import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function AttachModal({
  id,
  detachAdministrator,
  history,
  getSingleEndorsingOffices,
  detaching,
  dataInfo
}) {
  const [formData, setFormData] = useState([]);

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    const adminUserList = formData ? formData.map(data => +data.value) : [] || [];

    const args = {
      administrators: adminUserList
    }

    detachAdministrator(id, args, () => {
      setModal({ isOpen: false });
      history.push(`/bpls/settings/endorsing-offices/${id}`);
      getSingleEndorsingOffices(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const administratorOptions = _.get(dataInfo, 'included.administrators') 

  const selectAdministrator = administratorOptions.map(x => ({
    label: `${_.get(x, 'attributes.name')}`,
    value: x.id,
    id: x.id
  }));

  const handleDropDownChange = item => {
    setFormData(
      item
    );
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Select Administrator: 
            </label>
            <Select
              options={selectAdministrator}
              placeholder="Select Administrator"
              onChange={handleDropDownChange}
              isMulti
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={detaching}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {detaching ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={detaching}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AttachModal.propTypes = {
  id: PropTypes.string.isRequired,
  detachAdministrator: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleEndorsingOffices: PropTypes.instanceOf(Function).isRequired,
  detaching: PropTypes.bool.isRequired,
  dataInfo: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  detaching: api.loading.indexOf(c.DETACH_ADMINISTRATOR) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AttachModal);
